import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GaugeChartComponent } from './gaugeChart.component';

@NgModule({
  imports: [CommonModule],
  declarations: [GaugeChartComponent],
  exports: [GaugeChartComponent],
})
export class GaugeChartModule {}
